/**
 * test vad gör ni
 */

acf.addAction('ready', function () {
  inputHidden();
});

acf.addAction('af/form/page_changed', function () {
  stepsLoader();
});

acf.addAction('append', function ($el) {
  addIndexToRepeaterRow($el);
});

/**
 *
 */
function addIndexToRepeaterRow($el) {
  if ($el.hasClass('acf-row')) {
    let repeaterRowIndex = jQuery($el).index();
    jQuery($el).addClass('acf-row-index-' + repeaterRowIndex);
  }
}


/**
 *
 */
function stepsLoader() {
  var step = $('.af-page-button.current').data('index');
  $('.workshop-form-steps-header__content').removeClass('workshop-form-steps-header__content--active');
  $('.workshop-form-steps-header__content[data-index=' + '"' + step + '"]').addClass('workshop-form-steps-header__content--active');
  workshop_steps_counter(step);
}

/**
 *
 */
function workshop_steps_counter(step) {
  var ws_step_counter = acf.getFields({
    name: 'ws_step_counter_' + get_language(),
    limit: 1,
  });

  ws_step_counter[0].val(step);
}

/**
 *
 */
function inputHidden() {
  jQuery('.ws-id-auth').attr('hidden', true);
  jQuery('.ws-step-counter').attr('hidden', true);
  jQuery('.ws-relation').attr('hidden', true);
}

/**
 *
 */
function get_language() {
  return jQuery('html').attr('lang').toLowerCase().replace(new RegExp('-', 'g'), '_');
}

